// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__262s5","dragIcon":"SortableItem_dragIcon__1uakf","disabled":"SortableItem_disabled__1Vdmc"};